import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

interface DayIconProps extends SvgIconProps {
  text: 'MON' | 'TUE' | 'WED' | 'THU' | 'FRI' | 'SAT' | 'SUN' | string;
}

const DayIcon: React.FC<DayIconProps> = ({ text, ...props }) => {
  return (
    <SvgIcon {...props} viewBox="0 0 28 24">
      <text
        x="50%"
        y="50%"
        dominantBaseline="central"
        textAnchor="middle"
        fontSize="12px"
        fontWeight="bold"
        fill="currentColor"
      >
        {text}
      </text>
    </SvgIcon>
  );
};

export default DayIcon;
